import { DomainSheet } from "@/components/domain";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/(payments)/payments/$id/_sheet")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { id } = Route.useParams();

  return (
    <DomainSheet
      onClose={() => navigate({ to: "/payments/$id", params: { id } })}
    />
  );
}
